import { Button, Modal, Row } from 'antd';
import TextArea from 'antd/lib/input/TextArea';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { httpGet, httpPost, httpUrl } from '../../api/httpClient';
import '../../css/modal.scss';
import CloseIcon from '../../img/body/close.png';

class NcashMempDetailModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      memo: '',
    };
    this.formRef = React.createRef();
  }

  componentDidUpdate(prevProps, prevState) {}

  render() {
    const { isOpen, close, data } = this.props;
    return (
      <React.Fragment>
        {isOpen ? (
          <React.Fragment>
            <div className="Modal-overlay" onClick={close} />
            <div className="Modal">
              <div className="charge-content-all">
                <div className="charge-content-title">
                  <div className="charge-content-title-text">메모사항</div>
                </div>

                <div className="close-image" onClick={close}>
                  <img style={{ display: 'inline' }} src={CloseIcon} alt="" />
                </div>
                <div className="ncash-txt-container">
                  <p>{data.memo}</p>
                </div>
              </div>
            </div>
          </React.Fragment>
        ) : null}
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  const { loginReducer } = state;
  return { loginReducer };
};

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(NcashMempDetailModal);
